import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Popup from "../popup/Popup";
import { POPUP_FORM_CONTENT_CLASS, ACTION_POPUP_CONTENT_INNER_CLASS } from "../popup/popupLayoutSpec";
import { runTextPipeline } from "../../utils/contentSafety";
import {
  AccountPopupField,
  AccountPopupSaveFooter,
} from "./accountPopupFields";

const PortfolioEditPopup = ({ isOpen, onClose, onSave, initialData = null }) => {
  const [formData, setFormData] = useState({
    image: initialData?.image || null,
    title: initialData?.title || "",
    imagePreview: initialData?.imagePreview || null,
  });

  useEffect(() => {
    if (isOpen) {
      setFormData({
        image: initialData?.image || null,
        title: initialData?.title || "",
        imagePreview: initialData?.imagePreview || null,
      });
    }
  }, [isOpen, initialData]);

  const handleSave = () => {
    const trimmed = formData.title?.trim() ?? "";
    if (!trimmed) {
      toast.error("Please enter a title");
      return;
    }

    const contentResult = runTextPipeline(trimmed, "portfolioTitle");
    if (!contentResult.valid) {
      toast.error(contentResult.message || "Please check the title and try again.");
      return;
    }

    onSave({
      ...formData,
      title: contentResult.normalized ?? trimmed,
    });
    handleClose();
  };

  const handleClose = () => {
    setFormData({
      image: null,
      title: "",
      imagePreview: null,
    });
    onClose();
  };

  if (!isOpen) return null;

  const titleStep = {
    title: "Image Title",
    field: "title",
    placeholder: "Enter portfolio title...",
  };

  return (
    <Popup
      setTrigger={() => {}}
      ShowCrossButton={true}
      cross={true}
      onClose={handleClose}
      businessDashboard={true}
      hideLogoInHeader={true}
    >
      <div
        className="overflow-auto relative flex items-center justify-center"
        style={{ minHeight: "calc(100vh - 120px)" }}
      >
        <div className={POPUP_FORM_CONTENT_CLASS}>
          <div className={ACTION_POPUP_CONTENT_INNER_CLASS}>
            <form onSubmit={(e) => e.preventDefault()}>
              {formData.imagePreview ? (
                <div className="text-center mb-6">
                  <img
                    src={formData.imagePreview}
                    alt="Preview"
                    className="max-h-32 mx-auto rounded-lg shadow-md"
                  />
                </div>
              ) : null}
              <AccountPopupField
                step={titleStep}
                fieldKey="title"
                value={formData.title}
                onChange={(v) => setFormData((prev) => ({ ...prev, title: v }))}
                form={{ touched: {}, errors: {} }}
              />
              <AccountPopupSaveFooter
                onClick={handleSave}
                disabled={!formData.title.trim()}
              />
            </form>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default PortfolioEditPopup;
